<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="report">
        <p>
          <span class="report__back">
            <routerLink to="/reports">Report</routerLink>
          </span>
          >
          <span class="report__current">Report Summary</span>
        </p>
        <div class="report__header">
          <div class="report__header--text">Reports</div>
          <div class="report__header--edit">
              <img src="../../../assets/images/download2.svg" />&nbsp;
              <span>Download Report</span>
          </div>
        </div>

        <div class="report__body">
          <div class="report__body--loader" v-if="pageLoad">
            <div>
              <PageLoader />
            </div>
          </div>

          <div class="report__body--content" v-if="!pageLoad">
            <span
              >Regular Payroll Summary | {{ payrollHistory.month }},
              {{ payrollHistory.year }}</span
            >
            <p>
              This payroll was processed on {{ formatDate(payrollHistory) }} by
              {{ payrollAuthor }}.
            </p>
            <div>
              <div @click="showHome">
                <font-awesome-icon icon="angle-right" v-show="!home" />
                <font-awesome-icon
                  icon="angle-right"
                  v-show="home"
                />&nbsp;&nbsp;What Your Employees Take Home
              </div>
              <div @click="showHome">
                <font-awesome-icon icon="angle-right" v-show="!home" />
                <font-awesome-icon
                  icon="angle-right"
                  v-show="home"
                />&nbsp;&nbsp;What Gets Taxed and Debited
              </div>              
              <div @click="showHome">
                <font-awesome-icon icon="angle-right" v-show="!home" />
                <font-awesome-icon
                  icon="angle-down"
                  v-show="home"
                />&nbsp;&nbsp;What Your Company Pays
              </div>
              <div v-show="home">
                <div class="report__body--content-header">
                  <div>Employees ({{payrollBreakdown.length}})</div>
                  <div>Gross Pay</div>
                  <div>Company Taxes</div>
                  <div>Pension</div>
                  <div>Subtotal</div>
                </div>
                <div class="report__body--content-body">
                  <div
                    v-for="(payroll, index) in payrollBreakdown"
                    :key="index"
                  >
                    <div >
                      {{ payroll.breakdown.employee_details.firstname }}
                      {{ payroll.breakdown.employee_details.lastname }}
                    </div>
                    <div>
                      &#8358;{{
                        payroll.gross_pay
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "1,")
                      }}
                    </div>
                    <div>
                      &#8358;{{
                        payroll.breakdown.deductibles[0].value
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "1,")
                      }}
                    </div>

                    <div>
                      &#8358;{{
                        payroll.breakdown.deductibles[1].value
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      }}
                    </div>
                    <div>
                      &#8358;{{
                        payroll.subtotal
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      }}
                    </div>
                  </div>
                </div>
                <div class="report__body--content-footer">
                  <div>Totals</div>
                  <div>
                    &#8358;{{
                      totalGross
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </div>
                  <div>
                    &#8358;{{
                      totalPension
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </div>
                  <div>
                    &#8358;{{
                      totalTax
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </div>
                  <div>
                    &#8358;{{
                      totalAmount
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </div>
                  <!-- <div>&#8358;45,550</div>
                  <div>&#8358;45,550</div>-->
                </div>
                <div class="payroll__preview--details-total">
                  <span
                    >&#8358;{{
                      totalAmount
                        ? totalAmount
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                        : 0.0
                    }}</span
                  >
                  <p>Total Payroll</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "ReportSummary",
  components: {
    Header,
    Sidebar,
    PageLoader
  },
  data() {
    return {
      item: "report",
      home: true,
      debited: false,
      pay: false,

      pageLoading: true,
      payrollHistory: {},
      payrollBreakdown: [],
      payrollValue: [],
      dataFetchError: false,
      payrollAuthor: "",
      totalGross: 0,
      totalNet: 0,
      totalPension: 0,
      totalTax: 0,
      totalAmount: 0,
      pageLoad: true
    };
  },

  created() {
    this.getPayrollHistory();
  },

  methods: {
    showHome() {
      this.home = true;
      this.debited = false;
      this.pay = false;
    },
    showDebited() {
      this.home = false;
      this.debited = true;
      this.pay = false;
    },
    showPay() {
      this.home = false;
      this.debited = false;
      this.pay = true;
    },

    formatDate(payroll) {
      if (payroll.created_at) {
        const date = new Date(payroll.created_at);
        return date.toLocaleString().split(", ")[0];
      }
    },
    getPayrollHistory() {
      this.$http
        .get(`${types.PAYROLL_HISTORY_BREAKDOWN}/${this.$route.params.uuid}`)
        .then(resp => {
          this.payrollHistory = resp.data.data;
          this.payrollBreakdown = resp.data.data.breakdown;
          this.payrollAuthor = resp.data.data.created_by.name;
          this.calculate();
          this.pageLoad = false;
        })
        .catch(err => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    calculate() {
      for (let i = 0; i < this.payrollBreakdown.length; i++) {
        let grossPay = this.getGrossPay(this.payrollBreakdown[i]);
        this.payrollBreakdown[i].gross_pay = grossPay;
      }

      for (let i = 0; i < this.payrollBreakdown.length; i++) {
        let netPay = this.getNetPay(this.payrollBreakdown[i]);
        this.payrollBreakdown[i].net_pay = netPay;
      }

      for (let i = 0; i < this.payrollBreakdown.length; i++) {
        this.payrollBreakdown[i].subtotal = this.payrollBreakdown[i].gross_pay + this.payrollBreakdown[i].breakdown.deductibles[0].value
        + this.payrollBreakdown[i].breakdown.deductibles[1].value;
      }      

      this.calculateTotals();
    },

    calculateTotals() {
      let totalGross = 0;
      let totalNet = 0;
      let totalPension = 0;
      let totalTax = 0;
      for (let i = 0; i < this.payrollBreakdown.length; i++) {
        totalGross += this.payrollBreakdown[i].gross_pay;
        totalNet += this.payrollBreakdown[i].net_pay;

        totalPension += this.payrollBreakdown[i].breakdown.deductibles[0].value;
        totalTax += this.payrollBreakdown[i].breakdown.deductibles[1].value;
      }

      this.totalGross = totalGross;
      this.totalNet = totalNet;
      this.totalPension = totalPension;
      this.totalTax = totalTax;

      this.totalAmount = totalGross + totalPension + totalTax;
    },

    getGrossPay(payroll) {
      let sol = 0;

      if (payroll.breakdown.default_compensations) {
        payroll.breakdown.default_compensations.forEach(compensation => {
          sol += this.parseInt(compensation.value);
        });
      }

      if (payroll.breakdown.compensations) {
        payroll.breakdown.compensations.forEach(compensation => {
          sol += this.parseInt(compensation.value);
        });
      }

      return sol;
    },

    parseInt(val) {
      if (val) {
        return parseInt(val);
      }
      return 0;
    },

    getNetPay(payroll) {
      let sol = 0;

      if (payroll.breakdown.default_deductibles) {
        payroll.breakdown.default_deductibles.forEach(deductible => {
          sol += this.parseInt(deductible.value);
        });
      }

      if (payroll.breakdown.deductibles) {
        payroll.breakdown.deductibles.forEach(deductible => {
          sol += this.parseInt(deductible.value);
        });
      }

      return payroll.gross_pay - sol;
    }
  }
};
</script>

<style lang="scss" scoped>
.report {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  > p {
    font-size: 0.938vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .report__back {
      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    > .report__current {
      color: #707070;
    }
  }

  .report__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    padding: 5px 20px;
    justify-content: space-between;
    align-content: center;

    > .report__header--text {
      width: 500px;
      font-size: 2.083vw;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .report__header--edit {
      line-height: 28px;
      width: 150px;
      height: 30px;
      font-size: 0.878vw;
      line-height: 1.25;
      letter-spacing: 0.72px;
      color: #fff;
      text-align: right;
      background-color: #5099de;
      padding: 8px 10px;
      cursor: pointer;

      > img {
        width: 14px;
      }
    }
  }

  > .report__body {
    border-top: 1px solid #caced5;
    padding: 0 30px 0 5px;

    .payroll__preview--details-total {
      text-align: right;
      margin-top: 60px;
      padding-right: 20px;

      > span {
        font-size: 2.083vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #000000;
      }

      > p {
        font-size: 0.833vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.5;
        letter-spacing: normal;
        color: #707070;
        margin: 0;
      }
    }

    > .report__body--loader {
      margin-top: 50px;

      > div {
        width: 55px;
        margin: auto;
      }
    }

    > .report__body--content {
      padding: 50px 0;

      > span {
        font-size: 1.458vw;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        font-weight: 600;
      }

      > p {
        max-width: 52.083vw;
        font-size: 1.042vw;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin: 30px 0;
      }

      > div {
        margin-bottom: 30px;
        > div {
          font-size: 1.25vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: left;
          color: #5099de;
          cursor: pointer;
          margin-bottom: 30px;
        }

        > div {
          > .report__body--content-header {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-around;
            align-content: center;
            height: 50px;

            > div {
              width: 20%;
              font-size: 0.938vw;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              font-weight: 600;
            }
          }

          > .report__body--content-body {
            margin-top: 20px;
            border-top: 5px solid #5099de;
            border-bottom: 5px solid #5099de;

            > div {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-around;
              align-content: center;
              border-radius: 2px;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
              background-color: #ffffff;
              height: 60px;
              margin-bottom: 30px;

              > div {
                width: 20%;
                font-size: 0.938vw;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.22;
                letter-spacing: normal;
                text-align: center;
                color: #000000;

                > span {
                  font-size: 16px;
                }

                > p {
                  color: red;
                }
              }
            }
          }

          > .report__body--content-footer {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-around;
            align-content: center;
            height: 50px;

            > div {
              width: 20%;
              font-size: 1.25vw;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: center;
              color: #5099de;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
            }
          }
        }
      }
    }
  }
}
</style>
